import { Navigate, useParams } from 'react-router-dom';

import { useGetCosto } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCostos } from '../../shared/saveCostos';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateCostosPageInterface {}

const UpdateCostosPage: React.FC<UpdateCostosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_costo)
  const { id } = useParams();
  const { data, isLoading } = useGetCosto(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_costo) return <Navigate to="/inventario/costos" />;

  return (
    <SaveCostos titlePage="Editar costos" editCostos={data.data} />
  );
};

export default UpdateCostosPage;
